import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import LoaderEquipment from "../../../loaders/LoaderEquipment";
import OtmTimelineItem from "./OtmTimelineItem";
import OtmTabla from "./OtmTabla";

const OtmBase = ({ fetchFn, cardStyle, titulo }) => {
    const { codigo } = useParams();
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);
    const [selectedOtm, setSelectedOtm] = useState(null);

    useEffect(() => {
        fetchFn(codigo)
            .then((res) => setData(res))
            .catch(() => setError(true));
    }, [codigo, fetchFn]);

    // 👉 Inicializar con la primera OTM y hacer scroll automático
    useEffect(() => {
        if (data && data.length > 0) {
            const firstOtm = data[0].otm;
            if (!selectedOtm) {
                setSelectedOtm(firstOtm);

                const target = document.getElementById(firstOtm);
                if (target) {
                    const navbarHeight = document.querySelector(".navbar")?.offsetHeight || 70;
                    const elementPosition = target.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = elementPosition - navbarHeight - 50;

                    window.scrollTo({ top: offsetPosition });
                }
            }
        }
    }, [data]);

    return (
        <div className="row">
            {/* Timeline */}
            <div className="col-xl-8">
                <div className="timeline timeline-inverse small">
                    {!data ? (
                        <LoaderEquipment />
                    ) : error ? (
                        <div className="p-3 text-danger">Error al cargar datos</div>
                    ) : (
                        data?.map((otm) => (
                            <OtmTimelineItem
                                key={otm.otm}
                                otm={otm}
                                setSelectedOtm={setSelectedOtm}
                                selectedOtm={selectedOtm}
                            />
                        ))
                    )}
                    <div>
                        <i className="far fa-clock bg-gray"></i>
                    </div>
                </div>
            </div>

            {/* Panel lateral */}
            <div className="col-xl-4">
                <OtmTabla
                    codigo={codigo}
                    data={data}
                    cardStyle={cardStyle}
                    titulo={titulo}
                    selectedOtm={selectedOtm}
                    setSelectedOtm={setSelectedOtm}
                />
            </div>
        </div>
    );
};

export default OtmBase;
